import type { IAccrualSettingsResponse } from "@redbelly-tokeniser/mystake-api-sdk";
import { companyService } from "../../../../util";
import { useYieldRead } from "../../companyInformation/shares/yield/useYieldRead";

export const ACCRUAL_SETTINGS_LOAD_ERROR = "Could not load the fund's yield settings.";

export interface IUseAccrualSettings {
  settings: IAccrualSettingsResponse | null;
  isLoading: boolean;
  loadError: string | null;
  notOffered: boolean;
  reload: () => void;
}

/**
 * Reads the fund's yield settings. Pass `enabled: false` when `isYieldOffered` is false, so a company
 * that cannot have yield makes no request.
 */
export const useAccrualSettings = (
  companyId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {}
): IUseAccrualSettings => {
  const load = enabled && companyId ? () => companyService.getAccrualSettings(companyId) : null;
  const { data, ...state } = useYieldRead(load, [companyId], ACCRUAL_SETTINGS_LOAD_ERROR);
  return { settings: data, ...state };
};
